import type { UserType } from 'src/auth/types';

import { getAccount } from './getAccount';
import { onAuthStateChanged } from './onAuthStateChanged';

class UserUtil {
  getAccount(userId: string) {
    return getAccount(userId);
  }

  onAuthStateChanged(callback: (user: UserType) => void) {
    return onAuthStateChanged(callback);
  }
}

export const User = new UserUtil();
